import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sample-divider',
  templateUrl: './sample-divider.component.html',
  styleUrls: ['./sample-divider.component.scss']
})
export class SampleDividerComponent implements OnInit {

  @Input() block: any;

  constructor() { }

  ngOnInit(): void {
  }

}
